<template>
    <div class="sliderElement">
        <h2><label :for="id">{{ $t(sliderHeader) }}</label></h2>
        <div class="slider-container">
            <div class="time-labels">
                <label class="time-label-min">{{ formatedSliderMinValue }}</label>
                <label class="slider-value-field">{{ timeToString }} </label>
                <label class="time-label-max">{{ formatedSliderMaxValue }}</label>
            </div>
            <div class="slider-set">
                <input
                    :id="id"
                    v-model="time"
                    type="range"
                    :min="minValue"
                    :max="maxValue"
                    :step="stepValue"
                    class="slider"
                    @change="updateMap"
                >
            </div>
        </div>
    </div>
</template>

<script lang="ts">
    import { Component, Emit, Prop, Vue, Watch } from "vue-facing-decorator"
    import Utils from "@/utils/utils"
    import moment from "moment"

    const utils = new Utils()

    /** Date Slider/range komponentti.
     * Komponentille annetaan max ja min date josta lasketaan sliderin koko.
     */
    @Component
    export default class DateSlider extends Vue {
        /** Sliderin tunniste  */
        @Prop({ type: String }) sliderId: string | undefined
        /** Sliderin min value esim 1.1.2022  */
        @Prop({ type: String }) sliderMinValueLabel: string | undefined
        /** Sliderin max value esim 31.12.2022  */
        @Prop({ type: String }) sliderMaxValueLabel: string | undefined
        /** Sliderin valintana oleva pvm jos tyhjä niin min value valittuna */
        @Prop({ type: String }) sliderCurrentDate: string | undefined
        /** Sliderin step kokonaislukuna min 1*/
        @Prop({ type: Number, default: 1 }) stepValue!: number
        /** Sliderin Otsikko  */
        @Prop({ type: String }) sliderHeader: string | undefined

        /** Muokataan valintoja -> palauttaa kaikki valitut arvot */
        @Emit("updateMap")
        updateMap() {
            const min = moment(this.sliderMinValueLabel, "MM-DD-YYYY").startOf("day")
            const current = min.add(this.time, "days")
            return current.format("MM-DD-YYYY")
        }

        time = 0
        minValue = 0

        mounted(): void {
            this.setCurrentDate()
        }

        @Watch("dates")
        /** asetaan oletuspäivä jos päivämäärät ovat muuttuneet*/
        setCurrentDate() {
            const min = moment(this.sliderMinValueLabel, "MM-DD-YYYY").startOf("day")
            const current = moment(this.sliderCurrentDate, "MM-DD-YYYY").startOf("day")
            this.time = moment.duration(current.diff(min)).asDays()
        }

        get dates() {
            return this.sliderMinValueLabel + "-" + this.sliderMaxValueLabel + "-" + this.sliderCurrentDate
        }

        get id(): string {
            return "slider-" + (this.sliderId ?? "")
        }

        /** lasketaan sliderin maksimi arvo = loppupvm - alkupvm päivissä */
        get maxValue(): number {
            const min = moment(this.sliderMinValueLabel, "MM-DD-YYYY").startOf("day")
            const max = moment(this.sliderMaxValueLabel, "MM-DD-YYYY").startOf("day")
            return moment.duration(max.diff(min)).asDays()
        }

        /** Muotoillaan silderin arvo aikaleimaksi näkyville */
        get timeToString(): string {
            const min = moment(this.sliderMinValueLabel, "MM-DD-YYYY").startOf("day")
            const current = min.add(this.time, "days")
            return utils.formatDateShort(current.toString())
        }

        get formatedSliderMinValue(): string {
            return utils.formatDateShort(this.sliderMinValueLabel)
        }

        get formatedSliderMaxValue(): string {
            return utils.formatDateShort(this.sliderMaxValueLabel)
        }
    }
</script>

<style scoped>
    .slider-container {
        background-color: var(--Traficom-main-color);
        border-radius: 10px 10px 6px 6px;
        padding: 5px 0px 0px 0px;
    }

    .time-labels {
        align-items: center;
        display: flex;
        justify-content: space-between;
    }

    .time-label-min {
        color: #ffffff;
        font-size: 0.8rem;
        margin-left: 8px;
    }

    .time-label-max {
        color: #ffffff;
        font-size: 0.8rem;
        margin-right: 8px;
    }

    .slider-value-field {
        color: #ffffff;
        font-size: 1rem;
    }

    .slider-set {
        background: #cce0e3 0% 0% no-repeat padding-box;
        border-radius: 0px 0px 6px 6px;
        height: 100%;
        width: 100%;
        display: flex;
        align-items: baseline;
    }

    .slider::-moz-range-track {
        background-color: #cce0e3;
    }

    .slider::-moz-range-progress {
        background-color: #cce0e3;
    }

    .slider::-ms-fill-upper {
        background-color: #cce0e3;
    }

    .slider {
    -webkit-appearance: none;
    width: 100%;
    height: 33px;
    background: #cce0e3 !important;
    border-radius: 0px 0px 6px 6px;
    outline: none;
    opacity: 0.9;
    -webkit-transition: .2s;
    transition: opacity .2s;
    }

    .slider:hover {
    opacity: 1;
    }

    .slider::-webkit-slider-thumb {
    -webkit-appearance: none;
    appearance: none;
    width: 5px;
    height: 33px;
    background: #3e8895;
    cursor: pointer;
    }

    .slider::-moz-range-thumb {
    width: 5px;
    height: 33px;
    background: #3e8895;
    cursor: pointer;
    }

</style>
